import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/audit-logs.js';
import form from '../forms/audit-logs.js';
import * as types from '../types.js';

const auditLogs = function()
{

	let audit_logs_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_users, this.queryAll()).then((data) => db.set('users', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_logs, query);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_log, id);
			_record['body'] = _record['body'] ? JSON.stringify(_record['body']) : '';
			return _record;
		},
		async saveRecord(data, old_data)
		{
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'id', label: 'Evento', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do evento' },
		{ index: 2, field: 'date_time', label: 'Data/Hora', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora de registro' },
		{ index: 3, field: 'user_id', label: 'Usuário', types: [types.datalist()], placeholder: '', title: 'Usuário', store: 'users', labels: ['name'] },
		{ index: 4, field: 'origin', label: 'Origem', types: [], placeholder: '0.0.0.0', title: 'IP de origem' },
		{ index: 5, field: 'agent', label: 'Agente',	types: [], placeholder: '', title: 'User-Agent' },
		{ index: 6, field: 'method', label: 'Método', types: [], placeholder: '', title: 'Método HTTP' },
		{ index: 7, field: 'path', label: 'URL', types: [], placeholder: '', title: 'URL' },
		{ index: 8, field: 'body', label: 'Dados', types: [], placeholder: '', title: 'Corpo da requisição' }
	];

	audit_logs_crud.run(
		'audit_logs',
		'Eventos',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default auditLogs;

